// Copyright (c) Docugami, Inc. All rights reserved.

import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { useState } from "react";
import { QualityControlDescriptionClickedSchema, TelemetryEvent } from "telemetry/TelemetryEvents";
import { Telemetry } from "telemetry/TelemetryManager";
import { LabelQualityControlDialog } from "components/reports/LabelQualityControlDialog";

export function useLabelQualityControlCommand(docsetId: string | undefined, labelId: string): IDocumentCommand {
    const [isActive, setIsActive] = useState(false);

    function getVisual(): JSX.Element | null {
        if (!isActive || !docsetId) {
            return null;
        }

        return (
            <LabelQualityControlDialog
                docsetId={docsetId}
                labelId={labelId}
                onClose={onClose}/>
        );
    }

    function onExecute() {

        Telemetry.trackEvent<QualityControlDescriptionClickedSchema>({
            docSetId: docsetId!,
            labelId: labelId,
            eventName: TelemetryEvent.QualityControlDescriptionClicked
        });
        setIsActive(true);
    }

    function onClose() {
        setIsActive(false);
    }

    return {
        id: "Label Settings",
        label: "Settings",
        isActive: isActive,
        isEnabled: true,
        visual: getVisual(),
        execute: onExecute
    }
}
